<ion-header *ngIf="modal"
            class="ion-no-shadow ion-no-border">
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button *ngIf="newsfeed?.editComment.id"
                        (click)="cancelCommentEdit()">
                <ion-icon slot="icon-only"
                          color="dark"
                          name="arrow-back">
                </ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-title *ngIf="!newsfeed?.editComment.id"
                   [innerHTML]="'NEWSFEED_HEADER_DETAIL' | trns"></ion-title>
        <ion-title *ngIf="newsfeed?.editComment.id"
                   [innerHTML]="'NEWSFEED_HEADER_EDIT_COMMENT' | trns"></ion-title>
        <ion-buttons slot="end">
            <ion-button *ngIf="!newsfeed?.editComment.id"
                        (click)="backClicked()">
                <ion-icon slot="icon-only"
                          color="dark"
                          name="close">
                </ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>


<div *ngIf="!plt.sizeSm && newsfeed?.promoted"
     class="promoted-title">{{ 'NEWSFEED_PROMOTED' | trns }}
</div>

<add-newsfeed *ngIf="edit"
              [newsfeed]="newsfeed"
              [event]="event"
              [user]="user"
              [showKeywords]="showKeywords"
              (onNewsfeedSended)="newsfeedSended($event)"
              (onCanceled)="newsfeedEditationCanceled($event)">
</add-newsfeed>

<div #detail
     [ngClass]="{'newsfeed-detail-box': !loading && modal && newsfeed}">

    <ion-item *ngIf="user && !edit && !loading"
              #newsfeedBox
              [ngClass]="{'main-box': modal,
              'no-comments': !(event.can(user.selected_participant.group_id, 'allow_newsfeed_comment') || newsfeed.editComment.id),
              'pinned': newsfeed.pinned,
              'promoted': newsfeed.promoted,
              'inactive': newsfeed.status == 0,
              'declined': newsfeed.status == 2,
              'modal': modal}">

        <ng-container *ngIf="newsfeed.participant_id && user?.selected_participant?.id != newsfeed.participant_id">
            <a class="button-action-menu"
               (click)="showActionMenu($event, newsfeed)">
                <span class="dot"></span>
                <span class="dot"></span>
                <span class="dot"></span>
            </a>
        </ng-container>

        <ion-grid tabIndex="-1">

            <ion-row *ngIf="plt.sizeSm"
                     tabIndex="-1"
                     class="status"
                     (click)="showModalDetail()">
                <ion-col *ngIf="newsfeed.pinned && !modal"
                         class="pinned-title ion-no-padding">
                    <svg-icon [applyClass]="true"
                              src="/assets/icons/ico-thumbtack.svg">
                    </svg-icon>
                    <span>{{ 'NEWSFEED_PINNED' | trns }}</span>
                </ion-col>

                <ion-col *ngIf="newsfeed.promoted"
                         class="promoted-title ion-no-padding">
                    {{ 'NEWSFEED_PROMOTED' | trns }}
                </ion-col>
                <ion-col *ngIf="newsfeed.edited"
                         class="edited-title ion-no-padding">
                    <svg-icon [applyClass]="true"
                              src="/assets/icons/write.svg">
                    </svg-icon>
                    {{ 'NEWSFEED_EDITED' | trns }}
                </ion-col>
            </ion-row>

            <ion-row class="header"
                     tabIndex="-1"
                     (click)="showAttendeeDetail(newsfeed)"
                     [ngClass]="{'clickable' : newsfeed.getRealParticipant()}">
                <ion-col *ngIf="!newsfeed.custom_participant_id"
                         class="percentage">
                    <percentage-circle class="percentage-circle"
                                       [matching]="user && user.canMatching(newsfeed.participant)"
                                       [picture]="user && user.canPicture(newsfeed.participant)"
                                       [attendee]="newsfeed.participant">
                    </percentage-circle>
                </ion-col>
                <ion-col *ngIf="newsfeed.custom_participant_id"
                         class="percentage">
                    <ion-avatar>
                        <img *ngIf="newsfeed.custom_participant?.getImageUrl()"
                             img-avatar
                             [src]="newsfeed.custom_participant?.getImageUrl()">
                        <percentage-circle *ngIf="!newsfeed.custom_participant?.getImageUrl()"
                                           class="percentage-circle"
                                           [picture]="false">
                        </percentage-circle>
                    </ion-avatar>
                </ion-col>
                <ion-col>
                    <strong *ngIf="!newsfeed.custom_participant_id">
                        {{ newsfeed.participant?.firstname }} {{ newsfeed.participant?.lastname }}
                    </strong>
                    <strong *ngIf="newsfeed.custom_participant_id">
                        {{ newsfeed.custom_participant?.getName() }}
                    </strong>

                    <span>
                        <ng-container *ngIf="!newsfeed.custom_participant_id && (newsfeed.participant?.company || newsfeed.participant?.city)">
                            <ng-container *ngIf="newsfeed.participant?.profession">{{ newsfeed.participant?.profession }} </ng-container>
                            <ng-container *ngIf="newsfeed.participant?.company">{{ newsfeed.participant?.company }}</ng-container>
                            <ng-container *ngIf="newsfeed.participant?.company && newsfeed.participant?.city">, </ng-container>
                            <ng-container *ngIf="newsfeed.participant?.city">{{ newsfeed.participant?.city }}</ng-container>
                        </ng-container>
                        <ng-container *ngIf="newsfeed.custom_participant_id">
                            {{ newsfeed.custom_participant?.getPosition() }}
                        </ng-container>
                    </span>

                    <p class="ago">{{newsfeed.created_at | dateAgo: userLang}}</p>

                </ion-col>
            </ion-row>

            <ion-row class="content ion-no-padding"
                     tabIndex="-1">


                <ion-col *ngIf="newsfeed.image && !newsfeed?.options.oneColumn && !plt.sizeSm"
                         size="4">
                    <div *ngIf="newsfeed.image"
                         (click)="showModalDetail()"
                         class="image-preview">
                        <img [src]="plt.createSignedLink(newsfeed.image_url)">
                    </div>
                </ion-col>
                <ion-col class="ion-no-padding">

                    <p *ngIf="!modal && newsfeed.translate(userLang, event.default_locale).message && !newsfeed.longTextVisible"
                       class="message">
                        <ng-container *ngIf="newsfeed.translate(userLang, event.default_locale).message_preview?.toString().length > postMaxLength">
                            <div (click)="showModalDetail(true)"
                                 [innerHtml]="newsfeed.translate(userLang, event.default_locale).message | striphtml | slice:0:postMaxLength | nl2br">
                            </div>
                            <span class="show-more"
                                  (click)="newsfeed.longTextVisible = true">
                                {{ 'SHOW_MORE' | trns }}
                                <svg-icon [applyClass]="true"
                                          src="/assets/icons/ico-arrow.svg"
                                          class="collapsible">
                                </svg-icon>
                            </span>
                        </ng-container>
                        <ng-container *ngIf="!(newsfeed.translate(userLang, event.default_locale).message_preview?.toString().length > postMaxLength)">
                            <span (click)="showModalDetail()"
                                  [innerHtml]="newsfeed.translate(userLang, event.default_locale).message | nl2br | linkify | safe:'html'"></span>
                        </ng-container>
                    </p>
                    <p class="message"
                       *ngIf="(modal || newsfeed.longTextVisible) && newsfeed.translate(userLang, event.default_locale).message">
                        <span [innerHtml]="newsfeed.translate(userLang, event.default_locale).message | nl2br | linkify | safe:'html'"></span>
                        <span *ngIf="!modal"
                              class="show-less"
                              (click)="newsfeed.longTextVisible = false">
                            {{ 'SHOW_LESS' | trns }}
                            <svg-icon [applyClass]="true"
                                      src="/assets/icons/ico-arrow.svg"
                                      class="collapsible opened">
                            </svg-icon>
                        </span>
                    </p>

                    <div *ngIf="newsfeed.carousels.length > 0"
                         #sliderBox
                         class="slider-box">
                        <ion-slides #slider
                                    [options]="slideOpts"
                                    (ionSlideTransitionEnd)="setStep()"
                                    [pager]="false">
                            <ion-slide *ngFor="let slide of newsfeed.carousels">
                                <img [src]="plt.createSignedLink(slide.image_url)" draggable="false" />
                            </ion-slide>
                        </ion-slides>
                        <div *ngIf="newsfeed.carousels.length > 1 && currentCarouselIndex > 0 "
                             class="navigation-button prev"
                             (click)="slidePrev()">
                            <svg-icon [applyClass]="true"
                                      src="/assets/icons/ico-arrow.svg"
                                      class="collapsible">
                            </svg-icon>
                        </div>
                        <div *ngIf="newsfeed.carousels.length > 1 && currentCarouselIndex < (newsfeed.carousels.length - 1)"
                             class="navigation-button next"
                             (click)="slideNext()">
                            <svg-icon [applyClass]="true"
                                      src="/assets/icons/ico-arrow.svg"
                                      class="collapsible">
                            </svg-icon>
                        </div>
                    </div>


                    <div class="keyword-list"
                         (click)="showModalDetail()"
                         *ngIf="newsfeed.keywords">
                        <ion-label *ngFor="let selectedKeyword of newsfeed.keywordsUnique"
                                   class="keyword">
                            #{{ selectedKeyword.keyword.translate(userLang, event.default_locale).name | cut: 80 }}
                        </ion-label>
                    </div>
                    <div class="file-list"
                         *ngIf="newsfeed.file || (newsfeed.image && (newsfeed.options.oneColumn || plt.sizeSm))">

                        <span *ngIf="newsfeed.image && (newsfeed.options.oneColumn || plt.sizeSm)"
                              class="image-link">
                            <img [src]="plt.createSignedLink(newsfeed.image_url, false, true)">
                        </span>

                        <a *ngIf="newsfeed.file"
                           (click)="plt.downloadFile(plt.createSignedLink(newsfeed.file_url), newsfeed.filename + '.pdf')"
                           class="file-link pointer">
                            <svg-icon [applyClass]="true"
                                      [src]="'/assets/icons/profile/pdf.svg'">
                            </svg-icon>
                            <span class="file-name">{{ newsfeed.filename }}</span>
                        </a>

                    </div>
                    <div *ngIf="newsfeed.link"
                         class="link"
                         [ngClass]="{'ion-no-padding': newsfeed.image && !newsfeed?.options.oneColumn && !plt.sizeSm}">
                        <a (click)="openLink(newsfeed.link, newsfeed.linkInNewTab)">
                            <ng-container *ngIf="newsfeed.link_name">
                                {{ newsfeed.link_name }}
                            </ng-container>
                            <ng-container *ngIf="!newsfeed.link_name">
                                {{ newsfeed.link }}
                            </ng-container>
                        </a>
                    </div>
                </ion-col>
            </ion-row>
            <ion-row *ngIf="newsfeed.video_embed_link && newsfeed.display_video"
                     class="content ion-no-padding"
                     tabIndex="-1">
                <ion-col>
                    <iframe [src]="newsfeed.video_embed_link | safe:'resourceUrl'"
                            sandbox="allow-scripts allow-same-origin allow-presentation"
                            allowfullscreen
                            allow="autoplay;fullscreen"
                            frameborder="0">
                    </iframe>
                </ion-col>
            </ion-row>

            <div class="action-buttons"
                 tabIndex="-1"
                 *ngIf="(user?.selected_participant?.id == newsfeed.participant_id) && !newsfeed.translate(userLang, event.default_locale).isHtml">

                <svg-icon *ngIf="newsfeed.status == 0"
                          [applyClass]="true"
                          src="/assets/icons/warning.svg"
                          class="inactive"
                          (click)="editUnconfirmedModal(newsfeed)"
                          [title]="'NEWSFEED_EDIT_UNCONFIRMED_ICON_TITLE' | trns">
                </svg-icon>
                <svg-icon [applyClass]="true"
                          src="/assets/icons/ico-edit.svg"
                          class="remove"
                          (click)="editNewsfeed(newsfeed)">
                </svg-icon>
                <svg-icon [applyClass]="true"
                          src="/assets/icons/ico-close.svg"
                          class="remove"
                          (click)="deleteNewsfeedConfirmation(newsfeed.id)">
                </svg-icon>
            </div>

            <ion-row class="footer"
                     tabIndex="-1">
                <ion-col>
                    <div class="response-buttons">
                        <svg-icon *ngIf="!user.selected_participant.invisible"
                                  [applyClass]="true"
                                  src="/assets/icons/ico-like.svg"
                                  class="like"
                                  [ngClass]="{'active': isLiked(newsfeed)}"
                                  (click)="toggleLike(newsfeed)">
                        </svg-icon>
                        <svg-icon *ngIf="user.selected_participant.invisible"
                                  [applyClass]="true"
                                  src="/assets/icons/ico-like.svg"
                                  class="like">
                        </svg-icon>
                        <span class="counter like-count">{{newsfeed.number_of_likes}}</span>

                        <span class="comments"
                              (click)="showComments()">
                            <svg-icon [applyClass]="true"
                                      src="/assets/icons/ico-message.svg"
                                      class="comment"></svg-icon>
                            <span class="counter comments-count">
                                {{newsfeed.comments.length}}
                                <span *ngIf="newsfeed.comments.length != 1">{{ 'NEWSFEED_COMMENT_COUNTER' | trns }}</span>
                                <span *ngIf="newsfeed.comments.length == 1">{{ 'NEWSFEED_COMMENT_COUNTER_SINGULAR' | trns }}</span>
                            </span>
                        </span>

                        <span *ngIf="!plt.sizeSm && newsfeed.edited"
                              class="edited-title">
                            <svg-icon [applyClass]="true"
                                      src="/assets/icons/write.svg">
                            </svg-icon>
                            <span>{{ 'NEWSFEED_EDITED' | trns }}</span>
                        </span>

                        <span *ngIf="!plt.sizeSm && newsfeed.pinned"
                              class="pinned-title">
                            <svg-icon [applyClass]="true"
                                      src="/assets/icons/ico-thumbtack.svg">
                            </svg-icon>
                            <span>{{ 'NEWSFEED_PINNED' | trns }}</span>
                        </span>

                        <span *ngIf="newsfeed.status == 2"
                              class="declined-title">
                            <span>{{ newsfeed.refuse_reason }}</span>
                        </span>
                    </div>
                </ion-col>
            </ion-row>

            <ion-row *ngIf="newsfeed.commentsVisible && (modal || !plt.sizeSm)"
                     class="comment-list ion-no-padding"
                     tabIndex="-1">
                <ion-col class="ion-no-padding">
                    <div class="content">
                        <ion-item *ngFor="let comment of newsfeed.comments"
                                  [ngClass]="{ 'has-error': validationErrors['message'], 'editing': comment.id == newsfeed.editComment.id }"
                                  class="comment ion-no-padding">
                            <ion-grid>
                                <ion-row class="header ion-no-padding"
                                         (click)="showAttendeeDetailByComment(comment)"
                                         [ngClass]="{'clickable' : comment.getRealParticipant()}">
                                    <ion-col *ngIf="!comment.custom_participant_id"
                                             class="percentage ion-no-padding">
                                        <percentage-circle class="percentage-circle"
                                                           [matching]="user && user.canMatching(comment.participant)"
                                                           [picture]="user && user.canPicture(comment.participant)"
                                                           [attendee]="comment.participant">
                                        </percentage-circle>
                                    </ion-col>
                                    <ion-col *ngIf="comment.custom_participant_id"
                                             class="percentage ion-no-padding">
                                        <ion-avatar>
                                            <img *ngIf="comment.custom_participant?.getImageUrl()"
                                                 img-avatar
                                                 [src]="comment.custom_participant?.getImageUrl()">
                                        </ion-avatar>
                                    </ion-col>
                                    <ion-col class="ion-no-padding">
                                        <strong *ngIf="!comment.custom_participant_id">
                                            {{ comment.participant?.firstname }} {{ comment.participant?.lastname }}
                                        </strong>
                                        <strong *ngIf="comment.custom_participant_id">
                                            {{ comment.custom_participant?.getName() }}
                                        </strong>

                                        <ng-container *ngIf="!comment.custom_participant_id  && (comment.participant?.company || comment.participant?.city)">
                                            <ng-container *ngIf="comment.participant?.profession">{{ comment.participant?.profession }} </ng-container>
                                            <ng-container *ngIf="comment.participant?.company">{{ comment.participant?.company }}</ng-container>
                                            <ng-container *ngIf="comment.participant?.company && comment.participant?.city">, </ng-container>
                                            <ng-container *ngIf="comment.participant?.city">{{ comment.participant?.city }}</ng-container>
                                        </ng-container>
                                        <ng-container *ngIf="comment.custom_participant_id">
                                            {{ comment.custom_participant?.getPosition() }}
                                        </ng-container>

                                        <p class="ago">{{comment.created_at | dateAgo: userLang}}</p>
                                    </ion-col>
                                </ion-row>

                                <div class="action-buttons"
                                     *ngIf="user?.selected_participant?.id == comment.participant_id">
                                    <svg-icon *ngIf="comment.id != newsfeed.editComment.id"
                                              [applyClass]="true"
                                              src="/assets/icons/ico-edit.svg"
                                              class="remove"
                                              (click)="editComment(newsfeed, comment)">
                                    </svg-icon>
                                    <svg-icon [applyClass]="true"
                                              src="/assets/icons/ico-close.svg"
                                              class="remove"
                                              (click)="deleteNewsfeedCommentConfirmation(newsfeed, comment.id)">
                                    </svg-icon>
                                </div>

                                <ion-row class="content">

                                    <ng-container *ngIf="(modal && plt.sizeSm) || comment.id != newsfeed.editComment.id">
                                        <ion-col size="12"
                                                 class="comment-message">
                                            <span [innerHtml]="comment.translate(userLang, event.default_locale).message | linkify | nl2br | safe:'html'"></span>
                                        </ion-col>
                                    </ng-container>

                                    <ng-container *ngIf="(!modal) && comment.id == newsfeed.editComment.id">
                                        <ion-col size="12"
                                                 class="ion-no-padding">
                                            <ion-textarea placeholder="{{ 'PLACEHOLDER_FEED_COMMENT' | translate }}"
                                                          ieTextareaFix
                                                          name="commentMessage"
                                                          inputmode="text"
                                                          spellcheck="false"
                                                          autocapitalize="off"
                                                          #commentMessage="ngModel"
                                                          rows="1"
                                                          [autoGrow]="true"
                                                          [(ngModel)]="newsfeed.editComment.message">
                                            </ion-textarea>

                                            <span class="error-message"
                                                  *ngIf="validationErrors['message']">
                                                {{ validationErrors['message'] }}
                                            </span>
                                        </ion-col>
                                        <ion-col size="12"
                                                 class="ion-no-padding ion-text-right">
                                            <ion-button *ngIf="newsfeed?.editComment.id"
                                                        class="btn-close"
                                                        (click)="cancelCommentEdit()">
                                                {{ 'BUTTON_CANCEL' | trns }}
                                            </ion-button>
                                            <ion-button color="primary"
                                                        class="post-comment-button"
                                                        [disabled]="submit"
                                                        (click)="postComment(newsfeed)">
                                                {{ 'BUTTON_SAVE' | trns }}
                                            </ion-button>
                                        </ion-col>
                                    </ng-container>

                                </ion-row>
                            </ion-grid>

                        </ion-item>
                    </div>
                    <div class="new-comment"
                         *ngIf="(!modal) && !newsfeed.editComment.id && event.can(user.selected_participant.group_id, 'allow_newsfeed_comment') && !user.selected_participant.invisible">
                        <ion-grid class="ion-no-padding ion-padding-top">
                            <ion-row [ngClass]="{ 'has-error': validationErrors['message'] }">
                                <ion-col size="9">
                                    <ion-textarea placeholder="{{ 'PLACEHOLDER_FEED_COMMENT' | translate }}"
                                                  ieTextareaFix
                                                  name="commentMessage"
                                                  inputmode="text"
                                                  spellcheck="false"
                                                  autocapitalize="off"
                                                  #commentMessage="ngModel"
                                                  rows="1"
                                                  [autoGrow]="true"
                                                  [(ngModel)]="newsfeed.editComment.message">
                                    </ion-textarea>
                                </ion-col>
                                <ion-col size="3">
                                    <ion-button color="primary"
                                                class="post-comment-button"
                                                [disabled]="submit"
                                                (click)="postComment(newsfeed)">
                                        {{ 'BUTTON_SAVE' | trns }}
                                    </ion-button>
                                </ion-col>
                            </ion-row>
                            <ion-row *ngIf="validationErrors['message']">
                                <ion-col size="9">
                                    <span class="error-message">
                                        {{ validationErrors['message'] }}
                                    </span>
                                </ion-col>
                            </ion-row>
                        </ion-grid>
                    </div>
                </ion-col>
            </ion-row>

        </ion-grid>

    </ion-item>

    <ng-container *ngIf="loading">
        <div class="content-centered-column">
            <div class="content-centered-row">
                <ion-spinner></ion-spinner>
            </div>
        </div>
    </ng-container>

    <div *ngIf="!loading && user && modal && newsfeed && (event.can(user.selected_participant.group_id, 'allow_newsfeed_comment') || newsfeed.editComment.id)"
         class="chat-box-form">
        <ion-row class="ion-no-padding">
            <ion-col size="12"
                     size-sm="9"
                     class="ion-no-padding">
                <ion-textarea rows="1"
                              ieTextareaFix
                              [autoGrow]="true"
                              (ionFocus)="plt.checkResize() "
                              (ionBlur)="plt.checkResize(false)"
                              cols="20"
                              [(ngModel)]="newsfeed.editComment.message"
                              [placeholder]="'PLACEHOLDER_FEED_COMMENT' | translate">
                </ion-textarea>
                <div *ngIf="plt.sizeSm"
                     class="send-icon">
                    <svg-icon *ngIf="!submitting"
                              [applyClass]="true"
                              (click)="postComment(newsfeed)"
                              class="fill-primary"
                              src="/assets/icons/ico-send.svg"></svg-icon>
                    <ion-spinner *ngIf="submitting"
                                 name="dots"></ion-spinner>
                </div>
            </ion-col>
            <ion-col *ngIf="!plt.sizeSm"
                     size="12"
                     size-sm="3"
                     class="ion-no-padding">
                <ion-button color="primary"
                            class="post-comment-button"
                            [disabled]="submit"
                            (click)="postComment(newsfeed)">
                    {{ 'BUTTON_SAVE' | trns }}
                </ion-button>
            </ion-col>
        </ion-row>
    </div>
</div>